import { render, staticRenderFns } from "./ship.vue?vue&type=template&id=a372f0f6&scoped=true&"
import script from "./ship.vue?vue&type=script&lang=js&"
export * from "./ship.vue?vue&type=script&lang=js&"
import style0 from "./ship.vue?vue&type=style&index=0&id=a372f0f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a372f0f6",
  null
  
)

export default component.exports